/** Default in-app destinations when the user is signed in (PWA / owner / admin). */

export const PUBLIC_HUB = "/";
export const OWNER_HUB = "/profile";
export const ORDER_HUB = "/orders";
export const ADMIN_HUB = "/admin/dashboard";
export const ADMIN_LOGIN = "/admin";

export function getCustomerHubPath() {
  try {
    if (localStorage.getItem("locket_jwt")) return OWNER_HUB;
    if (localStorage.getItem("order_account_session")) return ORDER_HUB;
  } catch {
    /* ignore */
  }
  return PUBLIC_HUB;
}

export function getAdminHubPath() {
  try {
    if (localStorage.getItem("admin_token")) return ADMIN_HUB;
  } catch {
    /* ignore */
  }
  return ADMIN_LOGIN;
}

/**
 * Header back: use history when possible; otherwise land on the signed-in hub (not marketing home).
 */
export function navigateAppBack(navigate, { fallback, admin = false } = {}) {
  const hub = admin ? getAdminHubPath() : getCustomerHubPath();
  const fallbackPath = fallback ?? hub;

  if (typeof window !== "undefined" && window.history.length > 1) {
    navigate(-1);
    return;
  }

  navigate(fallbackPath === PUBLIC_HUB && hub !== PUBLIC_HUB ? hub : fallbackPath, { replace: true });
}
